import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthService } from './services';

const SERVICES = [AuthService];

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [...SERVICES]
})
export class DataAccessAuthModule {}
